import { useEffect } from "react";
import { useHistory } from "react-router";
import { TIPO_CARTAO_CONVENIO, TIPO_CARTAO_TEUCARD, TipoCartao } from "models/tipoCartao";
import { ClientStatus } from "utils/clientStatus";
import { getItemLocalStore } from "utils/storeUtils";
import lock_icon from "../../../../assets/images/padlock.png";
import AppButton from "../../../../components/AppButton/AppButton";
import { LOCAL_STORE_CLIENTE } from "../../../../constants";
import { RouteNames } from "../../../../routes/routes";
import "./BloqueioSelecionaCartao.css";

/**
 * Tela intermediária exibida apenas quando o cliente possui os dois tipos de cartão
 * (TeuCard e Convênio). Se ele só tiver um tipo, a navegação pula direto para a
 * escolha do motivo de bloqueio.
 */
const BloqueioSelecionaCartao = () => {
  const history = useHistory();
  const { cartaoAtual, cartaoAtualConvenio, statusCliente } =
    getItemLocalStore(LOCAL_STORE_CLIENTE);

  const temAmbosCartoes = !!cartaoAtual && !!cartaoAtualConvenio;
  const clienteEmCobranca = statusCliente === ClientStatus.COBRANCA;

  const teucardDisponivel =
    !!cartaoAtual &&
    cartaoAtual.status === ClientStatus.ATIVO &&
    !clienteEmCobranca;
  const convenioDisponivel =
    !!cartaoAtualConvenio && cartaoAtualConvenio.status === ClientStatus.ATIVO;

  const selecionarCartao = (tipoCartaoSelecionado: TipoCartao) => {
    history.push({
      pathname: RouteNames.BLOQUEIO_ESCOLHA_MOTIVO,
      state: { tipoCartaoSelecionado },
    });
  };

  useEffect(() => {
    if (temAmbosCartoes) return;

    selecionarCartao(cartaoAtual ? TIPO_CARTAO_TEUCARD : TIPO_CARTAO_CONVENIO);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!temAmbosCartoes) return null;

  return (
    <div className="bloqueio-seleciona-cartao-content">
      <h1 id="bloqueio-seleciona-cartao-title">Bloqueio do Cartão</h1>

      <h3 id="bloqueio-seleciona-cartao-description">
        Selecione o cartão que deseja bloquear
      </h3>

      <div className="bloqueio-seleciona-cartao-buttons">
        <button
          className="normal"
          disabled={!teucardDisponivel}
          onClick={() => selecionarCartao(TIPO_CARTAO_TEUCARD)}
        >
          Teucard
        </button>

        <button
          className="normal"
          disabled={!convenioDisponivel}
          onClick={() => selecionarCartao(TIPO_CARTAO_CONVENIO)}
        >
          Convênio
        </button>
      </div>

      <AppButton
        content="Voltar"
        route={RouteNames.ATENDIMENTO_HOME}
        outlined={true}
        click={() => {}}
      />

      <img id="bloqueio-seleciona-cartao-padlock" src={lock_icon} alt="" />
    </div>
  );
};

export default BloqueioSelecionaCartao;
